// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__1A-eU","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__sKp2o"};